import { redHighlightColor } from "../constants/colors";
import { TextInput } from "./TextInput";
// import { StyleProps } from "../constants/StylePropsType";
// import helpIcon from "../assets/icons/helpIcon.png";
import Tooltip from "./Tooltip";

interface StyleProps {
  width?: string;
  height?: string;
  placeholder?: string;
  backgroundColor?: string;
  borderRadius?: string;
  value?: string | any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  id?: string;
  fontSize?: string;
  fontStyle?: string;
  marginInline?: string;
}

interface TextInputWithLabelProps extends StyleProps {
  label: string;
  id?: string;
  className?: string;
  errorMessage?: string;
  inputType?: string;
  pattern?: string;
  maxLength?: number;
  onInput?: any;
  hintIcon?: any;
  tooltipContent?: string;
  mandatory?: boolean;
  tooltipPosition?: any;
  name?: string;
  index?: any;
  maxValue?: any;
  disabled?: boolean;
}

const TextInputWithLabel: React.FC<TextInputWithLabelProps> = ({
  maxLength,
  name,
  maxValue,
  mandatory,
  index,
  hintIcon,
  tooltipContent,
  tooltipPosition,
  label,
  onInput,
  inputType,
  pattern,
  id,
  className,
  errorMessage,
  disabled,
  ...props
}) => {
  return (
    <div style={{ display: "block", marginTop: "10px" }} key={index}>
      <div style={{ marginLeft: "1%", display: "flex", alignItems: "center" }}>
        {mandatory ? (
          <>
            <label
              htmlFor={id}
              marginLeft={props.marginInline}
              marginRight={props.marginInline}
              fontSize={props.fontSize}
              fontStyle={props.fontStyle}
            >
              {label}
            </label>
            <p
              style={{
                color: redHighlightColor,
                fontSize: "30px",
                marginLeft: "10px",
              }}
            >
              *
            </p>
          </>
        ) : (
          <label
            htmlFor={id}
            marginLeft={props.marginInline}
            marginRight={props.marginInline}
            fontSize={props.fontSize}
            fontStyle={props.fontStyle}
          >
            {label}
          </label>
        )}
        {hintIcon && (
          <Tooltip content={tooltipContent}>
            <img
              style={{ width: "18px", height: "18px", marginTop: "-15px" }}
              src={hintIcon}
              alt="help-icon"
            />
          </Tooltip>
        )}
      </div>
      <TextInput
        maxValue={maxValue}
        name={name}
        className={className}
        maxLength={maxLength}
        onInput={onInput}
        pattern={pattern}
        inputType={inputType}
        errorMessage={errorMessage}
        id={id}
        marginInline={props.marginInline}
        disabled={disabled}
        {...props}
      />
      <p
        style={{
          marginLeft: props.marginInline,
          marginTop: "5px",
          color: "red",
        }}
      >
        {errorMessage}
      </p>
    </div>
  );
};

export default TextInputWithLabel;
